import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class BackupPlanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.backupPlan).get(options);
  }

  get(id) {
    return this.$resource(apis.backupPlan + id).get();
  }

  search(name = "", params) {
    return this.$resource(apis.backupPlan).get(assign(params, { name }));
  }

  post(item) {
    return this.$resource(apis.backupPlan).save(item);
  }

  activate(id) {
    return this.$resource(apis.backupPlan + id + "activate").save(id);
  }

  deactivate(id) {
    return this.$resource(apis.backupPlan + id + "deactivate").save(id);
  }

  update(id, item) {
    return this.$resource(apis.backupPlan + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default BackupPlanResource;



// WEBPACK FOOTER //
// ./src/resources/backupPlan/backupPlan.resource.js